module.exports = __webpack_public_path__ + "static/media/autometrics_logo.8e9584d5.png";